export default (value = '') => value.replace(/(?:^|\s)\S/g, (letter) => letter.toUpperCase());



// WEBPACK FOOTER //
// ./sources/filters/ucwords.js